import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function BellIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M14.5 11H15C15.6 11 16 11.4 16 12C16 12.6 15.6 13 15 13H1C0.4 13 0 12.6 0 12C0 11.4 0.4 11 1 11H1.5C2.2 10.3 3 9.3 3 8V5C3 2.2 5.2 0 8 0C10.8 0 13 2.2 13 5V8C13 9.3 13.8 10.3 14.5 11Z" />
        <path d="M8 16C6.9 16 6 15.1 6 14H10C10 15.1 9.1 16 8 16Z" />
      </svg>
    </Icon>
  );
}
